<!--
/**
 * peacohrm is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 peacohrm Inc., http://www.peacohrm.com
 *
 * peacohrm is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * peacohrm is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <div class="peacohrm-background-container">
    <div class="peacohrm-card-container">
      <oxd-text tag="h6" class="peacohrm-main-title">
        {{ $t('View Advance Request') }}
      </oxd-text>

      <oxd-divider />

      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-form-row>
          <oxd-grid :cols="2" class="peacohrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field v-model="request.employeeName" :label="$t('Employee Name')" placeholder="Employee Name"
                :rules="rules.employeeName" required :disabled="true" />
            </oxd-grid-item>
            <oxd-grid-item>
              <date-input v-model="request.requestedDate" label="Requesting Date " :rules="rules.requestedDate"
                :years="yearsArray" :disabled="true" required />
            </oxd-grid-item>
          </oxd-grid>
          <oxd-grid :cols="2" class="peacohrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field v-model="request.advanceAmount" :label="$t('Advance Amount')"
                placeholder="Advance Amount" :rules="rules.advanceAmount" required :disabled="true" />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field v-model="request.currency" type="select" :rules="rules.currency" :options="currencies"
                :label="$t('general.currency')" required :disabled="true" />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-form-row>
          <oxd-grid :cols="2" class="peacohrm-full-width-grid">
            <oxd-grid-item class="--span-column-2">
              <oxd-input-field v-model="request.purpose" type="textarea" :label="$t('Purpose')" :rules="rules.purpose"
                required :disabled="true" />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-divider />

        <oxd-form-actions>
          <required-text />
          <oxd-button display-type="ghost" :label="$t('general.cancel')" @click="onCancel" />
          <!--          <submit-button :label="$t('Save')" />-->
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {
  required,
  shouldNotExceedCharLength,
} from '@/core/util/validation/rules';
import { APIService } from '@ohrm/core/util/services/api.service';
import { navigate } from '@ohrm/core/util/helper/navigation';
// import ClaimEventDropdownVue from '../../components/ClaimEventDropdown.vue';

const employeeAdvanceRequest = {
  employeeName: '',
  advanceAmount: 0,
  currency: '',
  employee: 1,
  requestedDate: formatDate(new Date()),
  purpose: ''
};

function formatDate(date) {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const formattedDay = String(day).padStart(2, '0');
  const formattedMonth = String(month).padStart(2, '0');
  return `${formattedDay}-${formattedMonth}-${year}`;
}

export default {
  name: 'SubmitClaimRequest',

  props: {
    currencies: {
      type: Array,
      default: () => [],
    },
    empNumber: {
      type: Number,
      required: true
    }
  },

  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      // `/api/v2/reimbursement/employees_advance/${props.empNumber}/requests`,
      `/api/v2/reimbursement/employees_advance/requests`,

    );

    const httpUpdate = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/reimbursement/employee_requests',
    );

    return {
      http,
      httpUpdate
    };
  },

  data() {
    return {
      isLoading: false,
      request: { ...employeeAdvanceRequest },
      id: 0,
      rules: {
        employeeName: [required],
        advanceAmount: [required],
        currency: [required],
        requestedDate: [required],
        purpose: [required, shouldNotExceedCharLength(500)],
      },
    };
  },

  beforeMount() {
    this.isLoading = true;
    const currentPath = window.location.pathname; // Get the current path
    const idIndex = currentPath.lastIndexOf('/'); // Find the index of the last '/'
    const id = currentPath.substring(idIndex + 1); // Extract the ID from the path
    console.log(id);
    this.httpUpdate
      .get(id)
      .then((response) => {
        console.log("data", response);
        const { data } = response.data;
        this.request.employeeName = data.employeeName;
        this.request.advanceAmount = data.advanceAmount;
        this.request.currency = this.currencies.find(currency => currency.id === data.currency);
        this.request.requestedDate = this.formatDate(new Date(data.requestedDate.date));
        this.request.purpose = data.purpose;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },

  methods: {
    onCancel() {
      window.history.back();
    },
    formatDate(date) {
      const isoDate = date.toISOString();
      return isoDate.substring(0, 10); // Return date in 'YYYY-MM-DD' format
    },
    onSave() {
      this.isLoading = true;
      this.http
        .create({
          advanceAmount: parseInt(this.request.advanceAmount),
          employee: 1,
          currency: this.request.currency.id,
          requestedDate: this.request.requestedDate,
          purpose: this.request.purpose
        })
        .then((res) => {
          this.id = res.data.data.id;
          return this.$toast.saveSuccess();
        })
        .then(() => {
          navigate('/reimbursement/submit_reimbursement/id/{id}', { id: this.id });
        })
        ;
    },
  },
};
</script>
